import { useState } from 'react';
import Link from 'next/link';
import cn from 'classnames';
import Tooltip from './Tooltip';
import { BatteryHealthOptionProps } from './types';
import {
  generateBatteryHealthDescription,
  generateBatteryHealthTitle,
} from '@/lib/collections/helpers';
import { priceFormater } from '@/settings/index';
import VariantBadge from '../../../VariantBadge';

const BatteryHealthOption = ({
  id,
  queryParams,
  isSelected,
  option,
  suggested,
  handleVariantSelection,
  offer,
  matchingOffer,
  className,
}: BatteryHealthOptionProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  if (suggested) return null;

  const priceDifference = matchingOffer.price - offer.price;

  return (
    <div className={cn(className)}>
      <Link
        href={{
          pathname: '/collections/[handle]',
          query: queryParams.toString(),
        }}
        scroll={false}
        shallow
      >
        <a
          data-suggested={suggested}
          id={id}
          onMouseEnter={() => {
            if (suggested) setIsTooltipOpen(true);
          }}
          onMouseLeave={() => {
            if (suggested) setIsTooltipOpen(false);
          }}
          onClick={() => {
            setIsTooltipOpen(false);
            handleVariantSelection();
          }}
          className={cn(
            'relative flex h-[50px] w-full items-center justify-between rounded border px-2 text-left',
            {
              'border-slate-gray-200 hover:border-gray-700 hover:text-gray-700':
                !isSelected,
              'border-gray-700 font-bold': isSelected,
              'border-dashed text-slate-gray-200': suggested,
            },
          )}
        >
          <div className="w-full">
            <div className="flex items-center justify-between gap-x-3">
              <span className="block">
                {generateBatteryHealthTitle(option)} Battery
              </span>
              {priceDifference !== 0 && (
                <span className="block">
                  {priceDifference > 0 ? '+' : ''}
                  {priceFormater.short(priceDifference)}
                </span>
              )}
            </div>
            <span className="block font-light text-gray-700/60">
              {generateBatteryHealthDescription(option)}
            </span>
            <VariantBadge badge={matchingOffer.badge?.batteryHealth} />
          </div>
        </a>
      </Link>
      {isTooltipOpen && <Tooltip />}
    </div>
  );
};

export default BatteryHealthOption;
